import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <MediaSection />
        <ContactSection />
        <CarouselSection />
        <FaqSection />
        <AboutSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}